var map = {
	"./1": [
		"f31c",
		"tournamentCover"
	],
	"./1.vue": [
		"f31c",
		"tournamentCover"
	],
	"./2": [
		"f554",
		"tournamentCover"
	],
	"./2.vue": [
		"f554",
		"tournamentCover"
	],
	"./3": [
		"184a",
		"tournamentCover"
	],
	"./3.vue": [
		"184a",
		"tournamentCover"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "c463";
module.exports = webpackAsyncContext;